import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";

import { VisibilityBlock } from "./VisibilityBlock";

interface VisibilityBlockContainerProps {
    bindingPath: AbsoluteModelPath;
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: VisibilityBlockContainerProps) => {
    const { bindingPath, viewModelSelect } = ownProps;

    const visible = Boolean(viewModelSelect.controlModel(state, bindingPath).value);

    return { visible: visible };
};

export const VisibilityBlockContainer = withResolvePaths(
    withViewModelSelect(connect(mapStateToProps)(VisibilityBlock))
);
